'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var generateLegend = function () { return ({
    align: 'left',
    verticalAlign: 'middle',
    layout: 'vertical',
    itemMarginBottom: 10,
    itemStyle: {
        font: '15px "TT Commons", Arial, sans-serif',
    },
}); };

exports.generateLegend = generateLegend;
